import React, { useEffect, useRef, useState } from 'react';

const VideoPlayer = ({
  src,
  poster,
  captionsSrc = null,
  title,
  className = '',
  showCaptionsNote = false,
}) => {
  const videoRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!isLoaded) {
      return undefined;
    }

    const video = videoRef.current;
    if (!video) {
      return undefined;
    }

    video.muted = false;
    video.load();
    video.play().catch(() => {
      /* native controls remain available */
    });

    return undefined;
  }, [isLoaded, src]);

  return (
    <div className={`relative ${className}`}>
      <div className="relative aspect-video w-full overflow-hidden rounded-lg shadow-lg bg-black">
        {!isLoaded && poster && (
          <button
            type="button"
            onClick={() => setIsLoaded(true)}
            className="group absolute inset-0 z-10 flex w-full items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow focus-visible:ring-offset-2"
            aria-label={title ? `Play ${title}` : 'Play video'}
          >
            <img src={poster} alt="" className="absolute inset-0 h-full w-full object-cover" />
            <span className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors motion-reduce:transition-none" />
            <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-white/90 text-navy shadow-lg">
              <span className="ml-1 text-2xl" aria-hidden="true">
                ▶
              </span>
            </span>
          </button>
        )}

        <video
          ref={videoRef}
          className="h-full w-full object-contain"
          controls
          preload="none"
          poster={poster}
          playsInline
        >
          {isLoaded && <source src={src} type="video/mp4" />}
          {isLoaded && captionsSrc && (
            <track kind="captions" src={captionsSrc} srcLang="en" label="English" default />
          )}
          Your browser does not support the video tag.
        </video>
      </div>

      {title && (
        <div className="mt-3">
          <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
        </div>
      )}

      {showCaptionsNote && !captionsSrc && (
        <p className="mt-2 text-sm text-gray-600">Captions not yet available.</p>
      )}
    </div>
  );
};

export default VideoPlayer;
